import AddLoadView from './AddLoadView';

export default AddLoadView;
